import { Box, Flex, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface PageLayoutProps {
  title?: string;
  breadcrumb?: ReactNode;
  topContent?: ReactNode;
  children: ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ title, breadcrumb, topContent, children }) => {
  return (
    <Box bg="white" minH="100vh" px={{ base: "24px", md: "24px", xl: "48px" }} py="40px">
      {topContent && <Box mb="24px">{topContent}</Box>}
      {title && <Text fontSize="24px" fontWeight="600" pb="16px" mb="24px">{title}</Text>}
      <Box mx="auto">
        {breadcrumb && (
          <Flex mb="26px" justify="space-between" align="center">
            {breadcrumb}
          </Flex>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default PageLayout;
